<template>
  <div class="bear-file-list">
    <ul v-if="isTraffic">
      <li v-for="(file, i) in fileList" :key="i" class="bfl-item">
        <a :href="`/FileServer/FileDownload.aspx?guid=${file.GUID}`" target="_blank">{{ file.FILE_NAME }}</a>
        <el-button type="danger" class="btn-del" size="small" @click="delFile(i)">删除</el-button>
      </li>
    </ul>
    <ul v-else>
      <li v-for="(file, i) in fileList" :key="i" class="bfl-item">
        <a :href="file.url" target="_blank">{{ file.name }}</a>
        <span class="red">({{ file.md5 }})</span>
        <el-button v-if="isEdit" type="danger" class="btn-del" size="small" @click="delFile(i)">删除</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "BearFileList",
  props: {
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    isTraffic () {
      return __type__ === 'traffic'
    }
  },
  methods: {
    delFile(index) {
      this.$emit("del-file", index);
    },
  },
};
</script>
<style lang="scss" scoped>
.bear-file-list {
  text-indent: 0;
  li {
    a,
    span {
      display: inline-block;
    }
    a {
      color: #409eff;
    }
  }
  .red {
    color: red;
  }
}
</style>